/*
|--------------------------------------------------------------------------
| ログイン周り
|--------------------------------------------------------------------------|
*/
import PasswordForgot from "@/components/pages/auth/PasswordForgot.vue";
import PasswordReset from "@/components/pages/auth/PasswordReset.vue";
import Signin from "@/components/pages/auth/SignIn.vue";

/*
|--------------------------------------------------------------------------
| ルーターの設定
|--------------------------------------------------------------------------|
*/
export default [
	{
		path: "/",
		redirect: "/signin"
	},
	{
		name: "Signin",
		path: "/signin",
		component: Signin,
		meta: {
			requiresAuth: false,
			title: "KIZUNAコンパス管理システム｜ログイン",
			column: "before_login"
		}
	},
	{
		name: "PasswordForgot",
		path: "/password_forgot",
		component: PasswordForgot,
		meta: {
			requiresAuth: false,
			title: "KIZUNAコンパス管理システム｜パスワードのリセット",
			column: "before_login"
		}
	},
	{
		name: "PasswordReset",
		path: "/reset/:token",
		component: PasswordReset,
		meta: {
			requiresAuth: false,
			title: "KIZUNAコンパス管理システム｜パスワードの設定",
			column: "before_login"
		}
	}
];
